/* eslint-disable complexity */
import { useLocation, useParams } from 'react-router-dom';
import React from 'react';

import { QUERY_PARAMS } from '@futrli/shared-services';

import { BudgetOnboardingNav } from './budget-onboarding-nav';
import { BUDGET_ONBOARDING_STEP } from '../const';
import { ForecastType, OnboardingTypeSelect } from '../shared/onboarding-type-select';
import { OnboardingToggleOff } from '../shared/onboarding-toggle-off';
import { OnboardingCustomise } from '../shared/onboarding-customise';
import { OnboardingAdditionalControls } from '../shared/onboarding-additional-controls';
import { OnboardingReadyToGo } from '../shared/onboarding-ready-to-go';
import { EndOnboardingFlow } from '../components/end-onboarding-flow';
import { OnboardingActivity } from '../shared/onboarding-activity';
import { OnboardingExplained } from '../shared/onboarding-explained';

export const BudgetOnboardingContainer = () => {
  const { onboardingStep: tempOnboardingStep } = useParams();
  const onboardingStep = tempOnboardingStep as BUDGET_ONBOARDING_STEP;

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const forecastType = searchParams.get(QUERY_PARAMS.FORECAST_TYPE);

  const getOnboardingContent = () => {
    if (forecastType === ForecastType.FromLYA) {
      switch (onboardingStep) {
        case BUDGET_ONBOARDING_STEP.LYA_READY_TO_GO:
          return <OnboardingReadyToGo />;
        case BUDGET_ONBOARDING_STEP.LYA_ADDITIONAL_CONTROLS:
          return <OnboardingAdditionalControls />;
        case BUDGET_ONBOARDING_STEP.LYA_CUSTOMISE:
          return <OnboardingCustomise />;
        case BUDGET_ONBOARDING_STEP.LYA_TOGGLE_OFF:
          return <OnboardingToggleOff />;
        case BUDGET_ONBOARDING_STEP.SELECT_TYPE:
          return <OnboardingTypeSelect />;
        default:
          return <OnboardingTypeSelect />;
      }
    } else if (forecastType === ForecastType.WithAutoPredictions) {
      switch (onboardingStep) {
        case BUDGET_ONBOARDING_STEP.AUTO_PREDICTIONS_READY_TO_GO:
          return <OnboardingReadyToGo />;
        case BUDGET_ONBOARDING_STEP.AUTO_PREDICTIONS_ADDITIONAL_CONTROLS:
          return <OnboardingAdditionalControls />;
        case BUDGET_ONBOARDING_STEP.AUTO_PREDICTIONS_CUSTOMISE:
          return <OnboardingCustomise />;
        case BUDGET_ONBOARDING_STEP.AUTO_PREDICTIONS_EXPLAINED:
          return <OnboardingExplained />;
        case BUDGET_ONBOARDING_STEP.AUTO_PREDICTIONS_ACTIVITY:
          return <OnboardingActivity />;
        case BUDGET_ONBOARDING_STEP.SELECT_TYPE:
          return <OnboardingTypeSelect />;
        default:
          return <OnboardingTypeSelect />;
      }
    } else if (forecastType === ForecastType.FromScratch) {
      switch (onboardingStep) {
        case BUDGET_ONBOARDING_STEP.SCRATCH_CUSTOMISE:
          return <OnboardingCustomise />;
        case BUDGET_ONBOARDING_STEP.SCRATCH_ADDITIONAL_CONTROLS:
          return <OnboardingAdditionalControls />;
        case BUDGET_ONBOARDING_STEP.SCRATCH_READY_TO_GO:
          return <OnboardingReadyToGo />;
        default:
          return <OnboardingCustomise />;
      }
    } else {
      switch (onboardingStep) {
        case BUDGET_ONBOARDING_STEP.SELECT_TYPE:
          return <OnboardingTypeSelect />;
        default:
          return <OnboardingTypeSelect />;
      }
    }
  };

  return (
    <div>
      <BudgetOnboardingNav />
      {getOnboardingContent()}
      <EndOnboardingFlow />
    </div>
  );
};
